/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var E = /* @__PURE__ */ ((r) => (r.TEXT = "text", r.IMAGE = "image", r.ICON = "icon", r))(E || {}), R = /* @__PURE__ */ ((r) => (r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r))(R || {}), e = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.primary = "primary", r.INFO = "info", r.SUCCESS = "success", r.WARNING = "warning", r.ERROR = "error", r))(e || {}), N = /* @__PURE__ */ ((r) => (r.START = "start", r.CENTER = "center", r.END = "end", r.STRETCHED = "stretched", r))(N || {});
export {
  E as avatarType,
  N as cardActionsLayout,
  R as cardOrientation,
  e as cardType
};
